module.exports = __webpack_public_path__ + "static/media/hedgy_head.bf60e710.png";